import { commonUtils } from '../common_utils';

const ETUA_MIN_LOAN_AMOUNT = 500;
const ETUA_MAX_LOAN_AMOUNT = 100000;

export const etua = {
    removeGreenEffect() {
        $('.greenFadeEffectEtua').removeClass('updateSec');
    },
    loadYear(defaultYears) {
        $('#etuaLoanPeriod').empty();

        let startYear = 1,
            endYear = 18;
        for (let year = startYear; year <= endYear; year++) {
            $('#etuaLoanPeriod').append(new Option(year, year));
        }

        $('#etuaLoanPeriod').val(defaultYears);
    },
    slider() {
        let defaultYear = $('#etuaLoanPeriod').val();
        let loanAmount = $('#etuaLoanAmount').val();

        $('.greenFadeEffectEtua').addClass('updateSec');

        if (loanAmount < ETUA_MIN_LOAN_AMOUNT) {
            alert(Translations.ad_detail.finance.error.etua_min_loan_amount);
            loanAmount = ETUA_MIN_LOAN_AMOUNT;
            $('#etuaLoanAmount').val(loanAmount);
        }

        if (loanAmount > ETUA_MAX_LOAN_AMOUNT) {
            alert(Translations.ad_detail.finance.error.etua_max_loan_amount);
            loanAmount = ETUA_MAX_LOAN_AMOUNT;
            $('#etuaLoanAmount').val(loanAmount);
        }

        etua.loadYear(defaultYear);
        defaultYear = $('#etuaLoanPeriod').val();

        $.ajax({
            type: 'GET',
            url: Routing.generate('finance_etua'),
            data: `loanAmount=${loanAmount}&loanPeriod=${defaultYear}`,
            success(data) {
                let loanData = data.etua;
                let installment = '-',
                    effective = '-',
                    nominal = '-';
                if (loanData) {
                    installment = commonUtils.numberFormatByLocale(loanData.monthly_payment.toFixed(2));
                    effective = commonUtils.numberFormatByLocale(loanData.apr.toFixed(2));
                    nominal = commonUtils.numberFormatByLocale(loanData.nominal_interest.toFixed(2));
                }

                $('#etua_monthly_payment').html(installment);
                $('#etua_air').html(effective);
                $('#etua_mir').html(nominal);

                setTimeout(etua.removeGreenEffect, 1000);
            },
        });
    },
    submit(object) {
        commonUtils.dataLayer.getLoanButtonDataLayerEvent(object.data('bank-name'));

        let loanAmount = $('#etuaLoanAmount').val();
        let loanYear = $('#etuaLoanPeriod').val();
        // Note: Site specific source value is different
        let etuaUrl = {
            Nettiauto: 'https://online.etua.fi/hakemus/kulutusluotto?source=90066',
            Nettivene: 'https://online.etua.fi/hakemus/kulutusluotto?source=90070',
            Nettikone: 'https://online.etua.fi/hakemus/kulutusluotto?source=90068',
            Nettikaravaani: 'https://online.etua.fi/hakemus/kulutusluotto?source=90069',
            Nettivaraosa: 'https://online.etua.fi/hakemus/kulutusluotto?source=90065',
        };

        let loanUrl = `${etuaUrl[commonUtils.getVerticalName()]}&amount=${loanAmount}&tenor=${loanYear}`;

        // Always append &loantype=16 for Nettiauto Etua calculator
        if (commonUtils.isNettiauto()) {
            loanUrl += '&loantype=16';
        }

        window.open(loanUrl, '_blank');
    },
};
